<script lang="ts" setup>
defineProps<{
  modelValue: boolean
  loanLabels: StoryBlokLoanLabels
  loanExpenseRating?: number | string
  delayExpenseRating?: number | string
  qualityRating?: number | string
  extraRatingInfo?: StoryBlokRichText
}>()
defineEmits(['update:modelValue'])
const isMoreDetailsOpen = ref(false)
</script>

<template>
  <BaseModal :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)">
    <template #header>
      <h3>{{ loanLabels.rating }}</h3>
    </template>
    <template #content>
      <QualityIndexDescription :best-label="loanLabels.best" :worst-label="loanLabels.worst" />
      <StoryblokRichText :document="loanLabels.qualityIndexDescription" />
      <a
        v-if="loanExpenseRating || delayExpenseRating || qualityRating || useHasContent(extraRatingInfo)"
        class="flex gap-1 text-primary font-semibold my-6 cursor-pointer select-none"
        @click="isMoreDetailsOpen = !isMoreDetailsOpen"
      >
        <span>{{ loanLabels.moreDetails }}</span>
        <span :class="{ 'transform rotate-180': isMoreDetailsOpen }">
          <AppIcon size="20" icon="far-chevron-down" />
        </span>
      </a>
      <div v-if="isMoreDetailsOpen">
        <div v-if="loanExpenseRating || delayExpenseRating">
          <span>{{ loanLabels.expensesRatingDescription }}</span>
          <div class="flex flex-col justify-between mt-2 md:flex-row">
            <div class="flex items-center gap-1">
              <div class="w-4 h-4 rounded-full bg-[#28BF28]" />
              <span>{{ loanLabels.low }}</span>
            </div>
            <div class="flex items-center gap-1">
              <div class="w-4 h-4 rounded-full bg-[#FFCD0D]" />
              <span>{{ loanLabels.acceptable }}</span>
            </div>
            <div class="flex items-center gap-1">
              <div class="w-4 h-4 rounded-full bg-[#F06706]" />
              <span>{{ loanLabels.high }}</span>
            </div>
            <div class="flex items-center gap-1">
              <div class="w-4 h-4 rounded-full bg-[#CC0000]" />
              <span>{{ loanLabels.veryHigh }}</span>
            </div>
          </div>
        </div>
        <PageLoanExpenseBar
          v-if="loanExpenseRating" :value="Number(loanExpenseRating)"
          :expense-label="loanLabels.loanExpense" :low-label="loanLabels.low" :acceptable-label="loanLabels.acceptable"
          :high-label="loanLabels.high" :very-high-label="loanLabels.veryHigh" class="my-4"
        />
        <hr v-if="delayExpenseRating && loanExpenseRating">
        <PageLoanExpenseBar
          v-if="delayExpenseRating" :value="Number(delayExpenseRating)"
          :expense-label="loanLabels.delayExpense" :low-label="loanLabels.low" :acceptable-label="loanLabels.acceptable"
          :high-label="loanLabels.high" :very-high-label="loanLabels.veryHigh" class="my-4"
        />
        <div v-if="qualityRating" class="flex justify-between items-center">
          <span class="font-semibold text-sm">{{ loanLabels.microLoansRating }}</span>
          <QualityIndex :value="Number(qualityRating) / 10" />
        </div>
        <StoryblokRichText v-if="useHasContent(extraRatingInfo)" class="mt-1" :document="extraRatingInfo" />
      </div>
    </template>
  </BaseModal>
</template>
